import script from "./QRCode.vue?vue&type=script&setup=true&lang=js"
export * from "./QRCode.vue?vue&type=script&setup=true&lang=js"

import "./QRCode.vue?vue&type=style&index=0&id=7e878f29&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e878f29"]])

export default __exports__